import { c as _c } from "react/compiler-runtime";
import { ROUTES } from "@/utils/constants";
import Link from "next/link";
import { useRouter } from "next/router";
const footerContent = {
  copyright: (year: number) => `Copyright © ${year} Dimitar Daskalov. All rights reserved.`
};
export const Footer = () => {
  const $ = _c(5);
  const currentYear = new Date().getFullYear();
  const router = useRouter();
  const isOnSecretPage = router.pathname === ROUTES.SECRET;
  const t0 = "p-4 mt-auto text-center max-w-7xl mx-auto";
  const t1 = "body-small";
  const t2 = footerContent.copyright(currentYear);
  let t3;
  if ($[0] !== isOnSecretPage) {
    t3 = !isOnSecretPage && <Link href={ROUTES.SECRET} className="hidden lg:inline-block ml-2 opacity-0 hover:opacity-100 hover:animate-bounce transition-opacity duration-300" aria-label="Hidden easter egg">🥚</Link>;
    $[0] = isOnSecretPage;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <footer className={t0}><p className={t1}>{t2}{t3}</p></footer>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};